<template>
    <div class="mbody">
        <h1 style="justify-content: center;display: flex;" class="tit">Help</h1>
        <hr class="rounded">



        <h3 class="q_class"># How do I practice with Kadena before I mint the NFT?</h3>
        <h5 class="a_class">
            <p>- The contract is also deployed on chain 1 of Testnet, switch your wallet to Testnet and get some $KDA
                from <a target="_blank" href="https://faucet.testnet.chainweb.com">the faucet</a> and play with the site
                to get comfortable you know what is going on.</p>
        </h5>

        <hr class="rounded">




        <h3 class="q_class"># I have $KDA but I can't mint. What is wrong?</h3>
        <h5 class="a_class">
            <p>- Kadena is inherently a multichain blockchain. Your funds most probably reside on chain 0 or chain 1 of
                Kadena blockchain. To mint a coal NFT you need to bring your funds on chain 13. This is done by a
                crosschain transfer to yourself and It is easy to do.
                If you are using X-Wallet just send the amount to yourself on chain 13.</p>
        </h5>


        <hr class="rounded">

        <h3 id="nfr_help_id" class="q_class"># How do I acquire $KDA?</h3>
        <h5 class="a_class">
            <p>- The best place for buying $KDA in our opinion is <a target="_blank"
                    href="https://tradeogre.com/exchange/BTC-KDA">TradeOgre</a> because there is no KYC requirement,
                you can deposit various coins like BTC, LTC, XRP, ... and then trade for KDA, then withdraw your KDA
                into your X-Wallet and transfer crosschain to chain 13 as mentioned in the last part.</p>
        </h5>


        <hr class="rounded">

        <h3 class="q_class"># What is an NFR?</h3>
        <h5 class="a_class">
            <p>- The NFR (no front run) mechanism was implemented to combat potential miner front running. Before
                submitting the nonce you have to first lock in a NFR lock. then you will verify that the NFR
                is locked to your name. If the NFR was locked in your name then it is safe to submit the nonce </p>
        </h5>


        <hr class="rounded">
        <h3 class="q_class"># How do I strengthen my NFT to prevent it being stolen?</h3>
        <h5 class="a_class">
            <p>- On the <span class="mylinku" @click="$store.commit('changeView', ENUMS.VIEWS.MYNFTS)">My NFTs</span>
                tab you can find a cpu miner by pressing the "mine" button that tries to find a nonce for you. Notice
                that this is a dumb and slow miner and if someone comes up with a gpu miner they will outperform you in
                finding nonces. Lets see if the project becomes that successful that people will start to write miners
                for strengthening and stealing the NFTs</p>
        </h5>


        <hr class="rounded">

        <h3 class="q_class"># How do I steal someone's NFT?</h3>
        <h5 class="a_class">
            <p>- On the <span class="mylinku" @click="$store.commit('changeView', ENUMS.VIEWS.LISTNFTS)">"List
                    NFTs"</span> tab you can search for NFTs by ID and by pressing the "steal" button you can send them
                to
                the "Heists" tab. if you have previously found a nonce you can enter it in the field. If not you can
                send the NFT to the "Coal Mine" tab to use the dumb miner.</p>
        </h5>


        <hr class="rounded">

        <h3 class="q_class"># I mined a nonce that would haved strenghened an NFT but my browser crashed, what do I do?
        </h3>
        <h5 class="a_class">
            <p>- The strongest nonces you have found are recorded as long as you do not clear your browser cache, just
                bring back the NFT into the "coal mine" tab and it would continue from whre you left off.</p>
        </h5>


        <hr class="rounded">


        <h3 class="q_class"># I get all sorts of error messages interacting with the site?</h3>
        <h5 class="a_class">
            <p>- Make sure the account you are using has been created on the Chain 13. This means you should have at
                least some KDA dust on this account and make sure it is on chain 13. Just send some KDA dust to yourself
                on chain 13 and most of issues will be resolved.</p>
        </h5>

        <hr class="rounded">



    </div>
</template>

<script>

import ENUMS from '../Enums';

export default {
    name: ENUMS.VIEWS.HELP
    , data() {
        return {
            ENUMS: ENUMS

        }
    }
}

</script>

<style scoped>
.a_class {
    padding-left: 5%;
}

.q_class {
    padding-left: 1%;
}
</style>